import React from 'react';
import { Card } from '@mui/material';
import './style.css';
import '../shared/pageTabsNav.css';

const CustomTabs = ({ tabsData, activeTab, setActiveTab }) => {

  // Modify handleChange to prevent interaction with disabled tabs
  const handleChange = (index, disabled) => {
    if (!disabled) {
      setActiveTab(index);
    }
  };

  return (
    <Card
      className="sd-page-content-card"
      sx={{
        padding: "20px 40px",
        borderRadius: "12px",
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
        backgroundColor: "#fff",
      }}
    >
      <div className="tabs-container">
        <div className="tabs-header sd-tabs-header">
          {tabsData?.map((tab, index) => (
            <div
              key={index}
              className={`sd-tab ${activeTab === index ? 'sd-tab--active' : ''} ${tab.disabled ? 'sd-tab--disabled' : ''}`}
              onClick={() => handleChange(index, tab.disabled)}
            >
              {index + 1}. {tab.label}
            </div>
          ))}
        </div>
        {tabsData?.map((tab, index) => (
          <div
            key={index}
            className={`tab-content ${activeTab === index ? 'tab-content-active' : ''}`}
          >
            <div className="tab-content-inner">{tab.content}</div>
          </div>
        ))}
      </div>
    </Card>
  );
};

export default CustomTabs;